import React from 'react';
import { AiOutlineShareAlt } from "react-icons/ai";
import "./Card.css";

const Card = (props) => {
  return (
    <div className="card">
      <div className="picture"> 
        <img src={props.image} alt={props.title} />
      </div>

      <div className="card__details">
        <div className="card__details__top">
          <h2 className='title'>{props.title}</h2>
        </div>

        <div className="card__details__middle">
          <p className="description">
            {props.data.description}
          </p>
        </div>

        <div className="card__details__bottom">
          <div className="button__container">
            <a href={props.demoLink} target="_blank" className="btn btn__primary">Click Here</a>
            <div className="btn__share"><AiOutlineShareAlt/></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Card;
